/**************************************************************************************************/
/*   File: /src/app/shared/enums/report.status.enum.ts                                            */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The report status enum
 */
export enum ReportStatusEnum {
    /**
     * The report exists and has positive result
     */
    EXISTS_AND_POSITIVE = 1,
    /**
     * The report exists and has negative result
     */
    EXISTS_AND_NEGATIVE = 2,
    /**
     * The report not exists
     */
    NOT_EXISTS = 3
}